// extracted by mini-css-extract-plugin
module.exports = {"crossPrice":"Renew_crossPrice__2Mu9g","tips":"Renew_tips__2yPI0"};